import * as React from "react";
import * as styles from "./roundButton.module.scss"

export default function RoundButton({onClick}) {
  return (
    <button className={styles.button} onClick={onClick}>
      <span><span className={styles.sNew}>New</span> <span className={styles.sGame}>game</span></span>
    </button>
  )
}